import Token from './token'
import Form from './form'

export default {
  icon: 'question',
  label: 'Ask Question',
  type: 'sms',
  action: 'question',
  form: Form,
  token: Token
}
